export const GET_USERS_LIST_SEARCH = '@@payments/GET_USERS_LIST_SEARCH';
export const GET_USERS_LIST_SEARCH_SUCCESS = '@@payments/GET_USERS_LIST_SEARCH_SUCCESS';
export const GET_USERS_LIST_SEARCH_ERROR = '@@payments/GET_USERS_LIST_SEARCH_ERROR';
